import * as angular from 'angular';
import type { BaseSideBarWidget } from './mx-widgets-factory';
import type { SideBarWidgetsFactory } from './mx-widgets-factory';
import type { MxShellLeftSidebarService } from '../../../../Pandora/components/mx-shell-left-sidebar/mx-shell-left-sidebar-service';
import type { MxApplicationService } from '../../../../../App/services/mx-application-service';

export class MxShellWidgetsPanelService {
	static $inject = ['mx.SolutionBuilderAgent.SideBarWidgetsFactory', 'mx.shell.LeftSidebarService', 'mx.shell.AppsService'];

	public readonly widgets: BaseSideBarWidget[] = [];
	public navigationWidget?: BaseSideBarWidget;

	private _visible = false;
	public get visible() {
		return this._visible;
	}

	private _enabled = false;
	public get enabled() {
		return this._enabled;
	}

	private _initialized = false;
	public get initialized() {
		return this._initialized;
	}

	constructor(
		private readonly sideBarWidgetsFactory: SideBarWidgetsFactory,
		private readonly leftSidebarService: MxShellLeftSidebarService,
		private readonly appsService: MxApplicationService
	) {}

	public async init() {
		const app = await this.appsService.getCurrentApplication();
		this._enabled = Boolean(app.simpleNavigation);

		if (this.enabled && !this.initialized) {
			this.initService();
			this._initialized = true;
		}
	}

	private initService() {
		this.leftSidebarService.addPanel({
			name: 'widgets',
			icon: 'list',
			title: '', //i18n.get('solutionBuilderAgent.common.widgets'),
			order: 10,
			disable: true,
			content: '<mx-widgets-panel></mx-widgets-panel>',
		});

		this.addWidgetByType('navigation');
	}

	public addWidget(widget: BaseSideBarWidget) {
		this.widgets.push(widget);

		this.widgets.sort((widgetA, widgetB) => widgetA.order - widgetB.order);

		this.checkVisibility();
	}

	public addWidgetByType(widgetType: string, order?: number) {
		switch (widgetType) {
			case 'navigation':
				this.navigationWidget = this.sideBarWidgetsFactory.createNavigationWidget(order);
				this.addWidget(this.navigationWidget as BaseSideBarWidget);
		}
	}

	public showWidget(widget: BaseSideBarWidget) {
		widget.visible = true;
		this.checkVisibility();
	}

	public hideWidget(widget: BaseSideBarWidget) {
		widget.visible = false;
		this.checkVisibility();
	}

	private checkVisibility() {
		this._visible = !this.widgets.every((widget) => !widget.visible);
		if (this.visible) {
			this.leftSidebarService.enablePanel('widgets');
		} else {
			this.leftSidebarService.disablePanel('widgets');
		}
	}
}

angular.module('mx.SolutionBuilderAgent').service('mx.SolutionBuilderAgent.WidgetsPanelService', MxShellWidgetsPanelService);
